import React, { useState, useEffect } from 'react';
import { useSiteContent } from '../context/SiteContentContext';

const HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/5673d3ec-9da0-4482-ba34-3bd63a96723f/images/5fba529f4f19e986acd4a7a8cfe3f6705025bcc0e1c9c2c73305412ffc96f00b.jpeg';

export const HeroCarousel = () => {
  const [active, setActive] = useState(0);
  const { c } = useSiteContent();

  const SLIDES = [
    { type: 'video', src: '/media/hero-theater.mp4', label: 'Cinema ambience' },
    { type: 'image', src: c('home.hero.slide2', HERO_IMG), label: 'Signature theater builds' },
    { type: 'image', src: c('home.hero.slide3', 'https://static.prod-images.emergentagent.com/jobs/5673d3ec-9da0-4482-ba34-3bd63a96723f/images/8e5e4befd1e8243af4ce2912044c65c8f2a8f9e64634ad0cde470a72702d9718.jpeg'), label: 'Private screening rooms' },
  ];

  useEffect(() => {
    const t = setInterval(() => setActive(a => (a + 1) % 3), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="absolute inset-0 bg-[#0f0f10]" data-testid="hero-carousel">
      {SLIDES.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-[1500ms] ease-in-out ${i === active ? 'opacity-65' : 'opacity-0'}`}
        >
          {s.type === 'video' ? (
            <video
              src={s.src}
              poster={HERO_IMG}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
              data-testid="hero-video"
            />
          ) : (
            <img src={s.src} alt={s.label} className="w-full h-full object-cover" />
          )}
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f0f10]/95 via-[#0f0f10]/55 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f10]/90 via-transparent to-transparent" />
      <div className="absolute bottom-8 right-8 z-10 flex items-center gap-2" data-testid="hero-carousel-dots">
        {SLIDES.map((s, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            aria-label={`Slide ${i + 1}`}
            aria-current={i === active ? 'true' : undefined}
            className={`h-1.5 rounded-full transition-all duration-500 ${i === active ? 'w-8 bg-[#D4AF37]' : 'w-3 bg-white/25 hover:bg-white/50'}`}
            data-testid={`hero-dot-${i}`}
          />
        ))}
      </div>
    </div>
  );
};
